export class IdValue{
    id:number;
    value:string;

    constructor(id:number,value:string) {
        this.id = id;
        this.value = value;        
    }
}